// Outflow.jsx

import React from "react";
import { Grid, withStyles } from "@material-ui/core";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { formatAmount } from "utils/Utils";
import { numericValueRegex } from "utils/Utils";
import { creditAssessmentFields } from "assets/properties/properties";
const styles = () => ({
  mainContainer: {
    width: "95%",
    margin: "20px auto",
    boxShadow: "0 10px 15px rgba(0,0,0,0.04)",
    border: "1px solid rgba(0,0,0,0.04)",
    padding: "10px 25px",
  },
  uploadContainer: {
    '& div[role="button"]': {
      height: "150px !important",
      margin: "0px 10px !important",
    },
  },
});
const Outflow = ({
  editable,
  setHouseHoldExpenditure,
  houseHoldExpenditure,
  otherEmi,
  setOtherEmi,
  classes,
  totalLoanAmountPerYear,
  actualLoanAmount,
  totalOutflowAmt,
  creditScore = 0,
  checkCreditScore,
  houseHoldExpenditureBlur,
  interestPayment,
  cibilReportUrl,
  skipAnnualIncomeValidations,
}) => {

  const totalOutFlow = () =>{
    return (
      <>
      <Grid item xs={12} md={2}  style={{display:"flex", flexDirection:'column', textAlign:'right'}}>
       {checkCreditScore && Number(creditScore) > 0 && <>
          <span style={{fontSize:'13px', fontWeight:700}}>Credit Score</span>
          <span style={{fontSize:'22px', fontWeight:700, color: "green"}}>{creditScore}</span>
      </>}
      </Grid>
      <Grid item xs={12} md={2}  style={{display:"flex", flexDirection:'column', textAlign:'right'}}>
      <span style={{fontSize:'13px', fontWeight:700}}>Total Outflow</span>
      <span style={{fontSize:'22px', fontWeight:700}}>{formatAmount(totalOutflowAmt)}</span>
      </Grid>
      </>
    )
  }
  return (
    <Grid container spacing={2} className={classes.mainContainer}>
      <Grid item xs={12}>
        <SubHeader label={creditAssessmentFields.outflowLabel}  message={totalOutFlow()} withRightText/>
      </Grid>

      <Grid item xs={12} md={3} className={classes.fieldContaienr}>
        <CustomeTextField
          label="Proposed Loan Amount"
          value={Math.round(actualLoanAmount).toLocaleString("en-IN")}
          disabled
        />
      </Grid>

      <Grid item xs={12} md={3} className={classes.fieldContaienr}>
        <CustomeTextField
          label="Existing Total Loan Amount"
          value={Math.round(totalLoanAmountPerYear).toLocaleString("en-IN")}
          disabled
        />
      </Grid>

      <Grid item xs={12} md={3} className={classes.fieldContaienr}>
        <CustomeTextField
          label="Interest Payment"
          value={Math.round(interestPayment).toLocaleString("en-IN")}
          disabled
        />
      </Grid>

      <Grid item xs={12} md={3} className={classes.fieldContaienr}>
        <CustomeTextField
          label="Household Expenditure"
          value={houseHoldExpenditure || ""}
          setState={(value) => {
            if (numericValueRegex(value)) {
              setHouseHoldExpenditure(value);
            }
          }}
          setBlur={houseHoldExpenditureBlur}
          disabled={!editable}
        />
      </Grid>
      {skipAnnualIncomeValidations && // using same flag for removing the current amount and previous loan amount as discussed in call
        <Grid item xs={12} md={3} className={classes.fieldContaienr}>
        <a href={cibilReportUrl} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'blue', marginLeft: '15px'}}>
          {cibilReportUrl && <span>View CIBIL Report</span>}
        </a>
        </Grid>
      }
      {checkCreditScore && <Grid item xs={12} md={3} className={classes.fieldContaienr}>
        <CustomeTextField
          label="Other Bank/NBFC EMI Obligations"
          value={otherEmi}
          setState={setOtherEmi}
          disabled
        />
      </Grid>}
    </Grid>
  );
};

export default withStyles(styles)(Outflow);
